import {
  AfterViewChecked,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges, OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';

import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Pagination} from '../../Models/Pagination';
import {Helper} from '../../../helpers/helper.service';
import {ActionColumn, ActionItem, BooleanColumn, DateColumn, ImageColumn, LinkColumn, ListColumn, NumberColumn, TextColumn} from '../../Models/columns';
import {BroadcastService} from '../../Services/broadcast.service';
import {Grid} from '../../Models/grid';
import {HttpParams} from '@angular/common/http';
import {Order} from '../../../back-office/Models/Order';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../Services/authentication.service';
import {Observable, Subject, Subscription} from 'rxjs';
import {debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';
import {DataTableService} from '../../Services/data-table.service';

class SearchQuery {
  public page = 1;
  public limit = '25';
  public offset = 0;
  public count = 0;
  public sortType: string;
  public sortBy: string;
  public query = '';
  public search = [];
  public status;
  public invoiceStatus;
  public isCredit;
  public backofficeInvoiceStatus;
  public filter = {};

  intLimit() {
    return parseInt(this.limit);
  }
}

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss', '../../../../assets/icon/icofont/css/icofont.scss']
})

export class GridComponent implements OnInit, OnChanges, OnDestroy, AfterViewChecked {
  /**
   * This is change waiting time for request for result after typing end
   */
  static DEBOUNCE_TIME = 1000;

  public selectedIds = [];
  public selectedItems: any[] = [];
  public static interval = null;
  public locale = 'en';
  public selectedAction: string;
  private currentComponentWidth;
  public checkedAll = false;
  tempSearchBody;
  openFilters = false;
  @ViewChild('gridRow', {static: false})
  gridRow: ElementRef;
  oldWidth = 0;

  @ViewChild('gridSystem', {static: false})
  table: DatatableComponent;

  @ViewChild('tableWrapper', {static: false}) tableWrapper;

  @ViewChild('boolColumnVal', {static: true})
  boolColumnVal: TemplateRef<any>;
  @ViewChild('boolColumnHeader', {static: true})
  boolColumnHeader: TemplateRef<any>;

  @ViewChild('textColumnVal', {static: true})
  textColumnVal: TemplateRef<any>;
  @ViewChild('textColumnHeader', {static: true})
  textColumnHeader: TemplateRef<any>;

  @ViewChild('dateColumnVal', {static: true})
  dateColumnVal: TemplateRef<any>;
  @ViewChild('dateColumnHeader', {static: true})
  dateColumnHeader: TemplateRef<any>;

  @ViewChild('numberColumnVal', {static: true})
  numberColumnVal: TemplateRef<any>;

  @ViewChild('numberColumnHeader', {static: true})
  numberColumnHeader: TemplateRef<any>;

  @ViewChild('linkColumnVal', {static: true})
  linkColumnVal: TemplateRef<any>;

  @ViewChild('listColumnVal', {static: true})
  listColumnVal: TemplateRef<any>;
  @ViewChild('listColumnHeader', {static: true})
  listColumnHeader: TemplateRef<any>;

  @ViewChild('actionsColumnHeader', {static: true})
  actionsColumnHeader: TemplateRef<any>;

  @ViewChild('actionColumnValue', {static: true})
  actionColumnValue: TemplateRef<any>;

  @ViewChild('imageColumnValue', {static: true})
  imageColumnValue: TemplateRef<any>;

  @ViewChild('imageColumnHeader', {static: true})
  imageColumnHeader: TemplateRef<any>;

  @ViewChild('gridSearch', {static: false}) gridSearch: ElementRef;

  loadingIndicator = true;

  @ViewChild('statusDropdownList', {static: false}) statusDropdownList: ElementRef;

  @Input() grid: Grid;
  @Input() buttonViewChange = false;

  LinkColumn = LinkColumn;
  searchQuery: SearchQuery = new SearchQuery();
  pagination: Pagination<any> = new Pagination<any>();
  @Input() itemsLimit = [
    '25',
    '50',
    '100'
  ];
  @Input() removeSelected;
  @Input() cancelMode: boolean;
  columns = [];
  wrapperWidth = 0;
  clientWidth = 0;
  fromDate;
  toDate;
  total: number = parseInt(this.searchQuery.limit);
  public disabledPosition = false;
  public confirmAction = false;
  public notifyAction = false;
  public calendarPlaceOrder: string;
  public messages = {
    emptyMessage: this.translator.instant('global.no_data'),
    totalMessage: this.translator.instant('global.total'),
    selectedMessage: this.translator.instant('global.selected')
  };

  public status = [
    {label: this.translator.instant('global.all'), value: 'all'},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.NEW['key']), value: Order.NEW['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.IN_PROCESS['key']), value: Order.IN_PROCESS['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.DELIVERY['key']), value: Order.DELIVERY['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.COMPLETED['key']), value: Order.COMPLETED['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.ON_HOLD['key']), value: Order.ON_HOLD['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.FREE_DELIVERY_AMOUNT_NOT_REACHED['key']), value: Order.FREE_DELIVERY_AMOUNT_NOT_REACHED['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.CANCELLED['key']), value: Order.CANCELLED['key']},
    {label: this.translator.instant('doctrine.order.statuses.' + Order.CHANGED['key']), value: Order.CHANGED['key']},
  ];
  public invoiceStatus = [
    {label: this.translator.instant('global.all'), value: 'all'},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_OPEN['key']), value: Order.INVOICE_OPEN['key']},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_PAID['key']), value: Order.INVOICE_PAID['key']},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_OVERDUE['key']), value: Order.INVOICE_OVERDUE['key']},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_CREDITED['key']), value: Order.INVOICE_CREDITED['key']},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_PARTIAL_PAID['key']), value: Order.INVOICE_PARTIAL_PAID['key']}
  ];

  public backofficeInvoiceStatus = [
    {label: this.translator.instant('global.all'), value: 'all'},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_OPEN['key']), value: Order.INVOICE_OPEN['key']},
    {label: this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_PAID['key']), value: Order.INVOICE_PAID['key']},
  ];


  public actions = [
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.NEW['key']), value: Order.NEW['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.IN_PROCESS['key']), value: Order.IN_PROCESS['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.DELIVERY['key']), value: Order.DELIVERY['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.COMPLETED['key']), value: Order.COMPLETED['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.ON_HOLD['key']), value: Order.ON_HOLD['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.FREE_DELIVERY_AMOUNT_NOT_REACHED['key']), value: Order.FREE_DELIVERY_AMOUNT_NOT_REACHED['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.order.statuses.' + Order.CANCELLED['key']), value: Order.CANCELLED['key']},
    {label: this.translator.instant('doctrine.order.generate_invoice') , value: 'generate_invoice'},
    {label: this.translator.instant('doctrine.order.generate_packaging_label') , value: 'generate_packaging_label'},
    {label: this.translator.instant('doctrine.order.alert_delivery_week_change') , value: 'delivery_change'},
    {label: this.translator.instant('doctrine.order.generate_sticker') , value: 'generate_sticker'},
    {label: this.translator.instant('doctrine.order.export_delivery') , value: 'export_delivery'},
  ];

  public backofficeInvoiceActions = [
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_OPEN['key']), value: Order.INVOICE_OPEN['key']},
    {label: this.translator.instant('doctrine.order.status_to') + ': ' + this.translator.instant('doctrine.invoice.statuses.' + Order.INVOICE_PAID['key']), value: Order.INVOICE_PAID['key']},
  ];

  public changeOrderStatusProcessing = false;
  public dateFrom;
  public dateTo;

  public searchSubject = new Subject<string>();

  @Output()
  sendParameters: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  totalCount: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  selectedRows: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output()
  selectedDataRows: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output()
  bulkActionResponse: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output()
  generateInvoiceAction: EventEmitter<any[]> = new EventEmitter<any[]>();
  private changeDetectorRef: any;
  subscription: Subscription;
  private gridServiceSubscription: Subscription = new Subscription();

  constructor(private broadcastService: BroadcastService, private translator: TranslateService,
              @Inject(ElementRef) public el: ElementRef, private auth: AuthenticationService, private dataTableService: DataTableService) {
    this.subscription = this.dataTableService.detectChanges().subscribe(message => {
      if (message) {
        if (this.table && this.table.recalculate && (this.tableWrapper.nativeElement.clientWidth !== this.currentComponentWidth)) {
          this.currentComponentWidth = this.tableWrapper.nativeElement.clientWidth;
          this.setColumns(window.innerWidth);
          this.table.recalculate();
          if (this.changeDetectorRef) {
            this.changeDetectorRef.detectChanges();
          }
        }
      }
    });
    this.wrapperWidth = el.nativeElement.offsetWidth;
  }

  ngOnInit(): void {
    if (sessionStorage.getItem(this.grid.rememberURL)) {
      this.searchQuery = Object.assign({}, JSON.parse(sessionStorage.getItem(this.grid.rememberURL)));
      this.total = parseInt(this.searchQuery.limit);
      if (this.searchQuery.search && this.searchQuery.search['undefined']) {
        delete this.searchQuery.search['undefined'];
      }
      if (this.grid.search) {
        this.grid.search.forEach(item => {
          if (item.searchArrays) {
            item.searchArrays.forEach(searchArray => {
              if (searchArray.selectedValue) {
                this.searchQuery.search[searchArray.name] = searchArray.selectedValue;
              }
            });
          }
        });
      }

    }
    this.calendarPlaceOrder = this.auth.getDateFormat().toLocaleLowerCase();
    this.searchSubject.pipe(
      debounceTime(GridComponent.DEBOUNCE_TIME),
      distinctUntilChanged(),
      switchMap((search, index) => new Observable((observer) => {
          this.sendRequest('resetPageOffset');
        }))
    ).subscribe(() => {});
    this.addSelectedItems();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.gridServiceSubscription.unsubscribe();
  }

  getCurrentPageTotal() {
    return this.total * (this.searchQuery.offset + 1);
  }


  public onResize() {
      this.clientWidth = window.innerWidth;
      this.wrapperWidth = this.el.nativeElement.offsetWidth;
      this.setColumns(window.innerWidth);
      this.table.recalculate();
  }

  private setColumns(width) {
    this.columns = [];
    for (let _i = 0; _i < this.grid.columns.length; _i++) {
      switch (this.grid.columns[_i].type) {
        case BooleanColumn.type:
          this.grid.columns[_i].cellTemplate = this.boolColumnVal;
          this.grid.columns[_i].headerTemplate = this.boolColumnHeader;
          this.grid.columns[_i].maxWidth = 30;
          this.grid.columns[_i].minWidth = 30;
          break;
        case TextColumn.type:
          this.grid.columns[_i].cellTemplate = this.textColumnVal;
          this.grid.columns[_i].headerTemplate = this.textColumnHeader;
          if (this.grid.columns[_i]['allowAdvance'] || this.grid.columns[_i]['allowAdvanceShowCallback']) {
            this.grid.columns[_i]['searchAdvance'] = [];
          }
          break;
        case NumberColumn.type:
          this.grid.columns[_i].cellTemplate = this.numberColumnVal;
          this.grid.columns[_i].headerTemplate = this.numberColumnHeader;
          break;
        case LinkColumn.type:
          this.grid.columns[_i].cellTemplate = this.linkColumnVal;
          this.grid.columns[_i].headerTemplate = this.textColumnHeader;
          break;
        case ListColumn.type:
          this.grid.columns[_i].cellTemplate = this.listColumnVal;
          this.grid.columns[_i].headerTemplate = this.listColumnHeader;
          if (this.grid.columns[_i]['isRemote']) {
            this.grid.columns[_i]['remoteService'][this.grid.columns[_i]['remoteServiceFunction']]().subscribe(resp => {
              this.grid.columns[_i]['staticData'] = resp;
            });
          }
          break;
        case ActionColumn.type:
          this.grid.columns[_i].cellTemplate = this.actionColumnValue;
          this.grid.columns[_i].headerTemplate = this.actionsColumnHeader;
          // this.grid.columns[_i].minWidth = (<ActionColumn>this.grid.columns[_i]).actionItems.length * 37;
          break;

        case ImageColumn.type:
          this.grid.columns[_i].cellTemplate = this.imageColumnValue;
          this.grid.columns[_i].headerTemplate = this.imageColumnHeader;
          break;

        case DateColumn.type:
          this.grid.columns[_i].cellTemplate = this.dateColumnVal;
          this.grid.columns[_i].headerTemplate = this.dateColumnHeader;
          break;
        default:
          this.grid.columns[_i].headerTemplate = this.textColumnHeader;
          this.grid.columns[_i].cellTemplate = this.textColumnVal;
      }
      if (this.grid.columns[_i].responsiveHideCallback) {

        if (!this.grid.columns[_i].responsiveHideCallback(width)) {
          for (const item in this.searchQuery.search) {
            if (this.searchQuery.search[item].name === this.grid.columns[_i]['prop']) {
              this.grid.columns[_i]['searchVal'] = this.searchQuery.search[item].value;
            }
          }
          this.columns.push(Object.assign({}, this.grid.columns[_i]));
        }
      } else {
        for (const item in this.searchQuery.search) {
          if (this.searchQuery.search[item] && this.searchQuery.search[item].name === this.grid.columns[_i]['prop']) {
            this.grid.columns[_i]['searchVal'] = this.searchQuery.search[item].value;
            if (this.grid.columns[_i]['type'] === DateColumn.type) {
              this.grid.columns[_i]['dateReferenceFrom'] = this.searchQuery.search[item].value['from'];
              this.grid.columns[_i]['dateReferenceTo'] = this.searchQuery.search[item].value['to'];
            }
          }
        }
        this.columns.push(Object.assign({}, this.grid.columns[_i]));
      }
    }
    // this.table.recalculateColumns(this.columns);
  }

  ngAfterViewChecked() {
    // Check if the table size has changed,
    // if (this.table && this.table.recalculate && (this.tableWrapper.nativeElement.clientWidth !== this.currentComponentWidth)) {
    //   this.currentComponentWidth = this.tableWrapper.nativeElement.clientWidth;
    //   this.table.recalculate();
    //   if (this.changeDetectorRef) {
    //     this.changeDetectorRef.detectChanges();
    //   }
    // }
  }

  ngOnChanges(changes: SimpleChanges): void  {
    if (Helper.isDefined(sessionStorage.getItem(this.grid.rememberURL)) && sessionStorage.getItem(this.grid.rememberURL) !== null) {
      this.searchQuery = JSON.parse(sessionStorage.getItem(this.grid.rememberURL));
    }

    //
    if (!Helper.isDefined(sessionStorage.getItem(this.grid.rememberURL)) || sessionStorage.getItem(this.grid.rememberURL) === null) {
      if (this.grid.defaultSort) {
        this.searchQuery.sortBy = this.grid.defaultSort;
        if (this.grid.defaultSortType) {
          this.searchQuery.sortType = this.grid.defaultSortType;
        } else {
          this.searchQuery.sortType = 'desc';
        }
      }
    }
    if (!Helper.isDefined(this.grid.root)) {
      this.grid.root = 'data';
    }

    this.setColumns(window.innerWidth);
    this.sendRequest(null);
    this.broadcastService.on('refreshGrid').subscribe(res => {
      if (res === this.grid.method) {
        this.disabledPosition = true;
        this.setColumns(window.innerWidth);
        this.sendRequest(null);
      }
    });

    if (GridComponent.interval == null) {
      GridComponent.interval = setInterval(function () {
        if (Helper.isDefined(this.table)) {
          this.table.recalculate();
        }

      }, 50);
    }
  }

  public sendRequest($e) {
    if (this.searchQuery.search['invoiceStatus'] == null) {
      this.searchQuery.search['invoiceStatus'] = 'all';
    }
    if (this.searchQuery.search['status'] == null) {
      this.searchQuery.search['status'] = 'all';
    }
    if (this.searchQuery.search['supplier_id'] == null) {
      this.searchQuery.search['supplier_id'] = 'all';
    }

    if (this.searchQuery.search['collection_id'] == null) {
      this.searchQuery.search['collection_id'] = 'all';
    }

    if (this.searchQuery.search['dealer_id'] == null) {
      this.searchQuery.search['dealer_id'] = 'all';
    }
    if (this.searchQuery.search['dealer_id'] == null) {
      this.searchQuery.search['dealer_id'] = 'all';
    }
    if (this.searchQuery.search['model_id'] == null) {
      this.searchQuery.search['model_id'] = 'all';
    }
    this.loadingIndicator = true;
    let searchBody = new HttpParams();
    if (this.searchQuery.query && $e === 'resetPageOffset') {
      this.searchQuery.offset = 0;
    }

    this.total = parseInt(this.searchQuery.limit);

    searchBody = searchBody.set('sortType', this.searchQuery.sortType);
    searchBody = searchBody.set('sortBy', this.searchQuery.sortBy);
    searchBody = searchBody.set('filter', encodeURIComponent(JSON.stringify(this.searchQuery.filter)));
    if (this.grid.search && this.grid.search[0].isInvoiceStatus) {
      searchBody = searchBody.set('invoiceStatus', this.searchQuery.search['invoiceStatus']);
    } else {
      searchBody = searchBody.set('status', this.searchQuery.search['status']);
    }
    searchBody = searchBody.set('per_page', this.searchQuery.limit + '');
    searchBody = searchBody.set('query', this.searchQuery.query);
    searchBody = searchBody.set('query', this.searchQuery.query);
    if (Helper.isDefined(this.searchQuery.isCredit)) {
      searchBody = searchBody.set('isCredit', this.searchQuery.isCredit);
    }
    if (Helper.isDefined(this.grid.params)) {
      this.grid.params.forEach((param) => {
        searchBody = searchBody.append('params[]', param);
      });
      if ($e === 'resetPageOffset') {
        this.searchQuery.offset = 0;
      }
    }
    if (Helper.isDefined(this.grid.archive)) {
      searchBody = searchBody.set('archive', (!!(this.grid.archive)).toString());
    }
    for (const item in this.searchQuery.search) {

      if (!this.searchQuery.search.hasOwnProperty(item)) {
        continue;
      }
      if (!Helper.isDefined(this.searchQuery.search[item])) {
        continue;
      }
      if (Array.isArray(this.searchQuery.search[item])) {
        if ($e === 'resetPageOffset') { this.searchQuery.offset = 0; }
        for (let _i = 0; _i < (<any[]>this.searchQuery.search[item]).length; _i++) {
          searchBody = searchBody.append('q[' + item + '][]', this.searchQuery.search[item][_i]);
        }
      } else if (this.searchQuery.search[item] !== null && typeof this.searchQuery.search[item] === 'object') {
        if ($e === 'resetPageOffset') { this.searchQuery.offset = 0; }
        if (item === 'from') {
          const d = <{ from: string }>this.searchQuery.search[item].day;
          const m = <{ from: string }>this.searchQuery.search[item].month;
          const y = <{ from: string }>this.searchQuery.search[item].year;
          this.dateFrom = y + '-' + m + '-' + d;
          searchBody = searchBody.set('q[' + item + ']', this.dateFrom);

        }
        if (item === 'to') {
          const d = <{ to: string }>this.searchQuery.search[item].day;
          const m = <{ to: string }>this.searchQuery.search[item].month;
          const y = <{ to: string }>this.searchQuery.search[item].year;
          this.dateTo = y + '-' + m + '-' + d;
          searchBody = searchBody.set('q[' + item + ']', this.dateTo);
        }
        /*    if ((<{ to: string }>this.searchQuery.search[item]).to) {
              searchBody = searchBody.set('q[' + item + '][to]', (<{ to: string }>this.searchQuery.search[item]).to);
            }*/

      } else {
        if ($e === 'resetPageOffset') { this.searchQuery.offset = 0; }
        searchBody = searchBody.set('q[' + item + ']', <string>this.searchQuery.search[item]);
      }
    }
    searchBody = searchBody.set('page', (this.searchQuery.offset + 1) + '');
    this.tempSearchBody = searchBody;
    this.sendParameters.emit(searchBody);
    if (Helper.isDefined(this.grid.rememberURL)) {
      sessionStorage.removeItem(this.grid.rememberURL);
      const searchQuerySearch = Object.assign({}, this.searchQuery.search);
      const searchQuery = Object.assign({}, this.searchQuery);
      searchQuery.search = searchQuerySearch;
      sessionStorage.setItem(this.grid.rememberURL, JSON.stringify(searchQuery));
    }
    this.messages.emptyMessage = this.translator.instant('global.no_data');
    const requestSubscription = this.grid.service[this.grid.method](searchBody, this.grid.params).subscribe({
      next: res => {
        if (!res) {
          this.pagination.data = [];
          this.loadingIndicator = false;
          this.disabledPosition = false;
          return;
        }

        this.searchQuery.count = res?.total;
        this.totalCount.emit(res?.total);
        const rows = [];

        if (this.grid.root === 'invoice' || this.grid.root === 'order' || this.grid.root === 'service') {
          for (const item of res?.['data'] ?? []) {
            if (item && Helper.isDefined(item['orderItemCollections'])) {
              item[this.grid.root]['orderItemCollections'] = item['orderItemCollections'];
            }
            rows.push(item[this.grid.root]);
          }
        } else {
          rows.push(...(res?.[this.grid.root] ?? []));
        }
        this.pagination.data = rows;
        this.loadingIndicator = false;
        this.disabledPosition = false;
      },
      error: () => {
        this.pagination.data = [];
        this.messages.emptyMessage = this.translator.instant('errors.500_content_line1');
        this.loadingIndicator = false;
        this.disabledPosition = false;
      },
    });

    this.gridServiceSubscription.add(requestSubscription);
  }

  onSort($e) {
    this.searchQuery.sortType = $e.newValue;
    this.searchQuery.sortBy = $e.column.prop;
    this.sendRequest(null);
  }

  searchColumn($e, column) {
    if ($e.keyCode === 13) {
      if (column.type === NumberColumn.type) {
        if (typeof column.searchValStart !== 'string' && typeof column.searchValEnd !== 'string') {
          return;
        }
        if (column.searchValStart.length === 0 && column.searchValEnd.length === 0) {
          this.removeSearchColumn(column.prop);
        } else {
          this.searchQuery.search.push({
            name: column.prop,
            value: {
              from: column.searchValStart,
              to: column.searchValEnd
            }
          });
        }
      } else if (column.type === ListColumn.type) {
        if (typeof column.searchVal !== 'string') {
          return;
        }
        if (column.searchVal.length === 0) {
          this.removeSearchColumn(column.listKey);
        } else {
          this.searchQuery.search.push({
            name: column.listKey,
            value: column.searchVal
          });
        }
      } else {
        if (typeof column.searchVal !== 'string') {
          return;
        }
        if (column.searchVal.length === 0) {
          this.removeSearchColumn(column.prop);
        } else {
          this.searchQuery.search.push({
            name: column.prop,
            value: column.searchVal
          });
        }
      }
      this.searchQuery.offset = 0;
      this.sendRequest(null);
    }

  }

  searchListColumn($e, column) {
    if (column.searchVal.length === 0) {
      this.removeSearchColumn(column.prop);
    } else {
      this.removeSearchColumn(column.prop);
      this.searchQuery.search.push({
        name: column.prop,
        value: column.searchVal
      });
    }

    this.searchQuery.offset = 0;
    this.sendRequest(null);
  }

  searchAdvanceItem(column, item) {
    const index = column.searchAdvance.indexOf(item.key);
    if (index !== -1) {
      column.searchAdvance.splice(index, 1);
    } else {
      column.searchAdvance.push(item.key);
    }
    let i: any = -1;
    for (const index in this.searchQuery.search) {
      if (this.searchQuery.search[index].name === column.advanceSearchKey) {
        i = index;
      }
    }
    if (i === -1) {
      this.searchQuery.search.push({
        name: column.advanceSearchKey,
        value: column.searchAdvance
      });
    } else {
      this.searchQuery.search[i] = {
        name: column.advanceSearchKey,
        value: column.searchAdvance
      };
    }
    this.sendRequest(null);
  }


  private removeSearchColumn(key) {
    let index = -1;
    for (let _i = 0; _i < this.searchQuery.search.length; _i++) {
      if (this.searchQuery.search[_i].name === key) {
        index = _i;
      }
    }
    this.searchQuery.search.splice(index, 1);
  }


  public onPage($event) {
    this.searchQuery.offset = $event.offset;
    this.searchQuery.limit = $event.limit;
    this.sendRequest(null);
  }

  clearSearch() {
    sessionStorage.removeItem(this.grid.rememberURL);

    this.searchQuery = new SearchQuery();
    for (let _i = 0; _i < this.columns.length; _i++) {
      if (this.columns[_i]['type'] === DateColumn.type) {
        this.columns[_i]['dateReferenceFrom'] = '';
        this.columns[_i]['dateReferenceTo'] = '';
      }
      // if(this.grid.columns[_i]["allowAdvance"]||this.grid.columns[_i]["allowAdvanceShowCallback"]){
      //     this.grid.columns[_i]["searchAdvance"]=[];
      // }
      if (this.columns[_i]['searchValStart']) {
        this.columns[_i]['searchValStart'] = undefined;
      }
      if (this.columns[_i]['searchValEnd']) {
        this.columns[_i]['searchValEnd'] = undefined;
      }
      delete this.columns[_i]['searchVal'];
    }
    this.sendRequest(null);

  }

  toggleExpandRow(row) {
    this.table.rowDetail.toggleExpandRow(row);
  }

  public setZIndexForHeader(event: number) {
    const element = document.querySelector('.datatable-header .datatable-row-center');
    if (element !== null) {
      if (event === 1) {
        (<any>element).style.zIndex = 9;
      } else {
        (<any>element).style.zIndex = 8;
      }
    }

  }

  openAdvanceSearch(column) {
    const element = document.querySelector('.datatable-header .datatable-row-center');
    column.advanceOpen = !column.advanceOpen;
    if (column.advanceOpen) {
      (<any>element).style.zIndex = 9;
    } else {
      (<any>element).style.zIndex = 8;
    }
  }

  getCSSClasses() {
    const v = this.grid.search;
    let cssClasses;
    if (v) {
      cssClasses = 'col-md-6';
    } else {
      cssClasses = 'col-md-9';
    }
    return cssClasses;
  }

  addSelected(event, row) {
    if (event.target.checked) {
      this.selectedIds.push(row.id);
      this.selectedItems.push(row);
      this.selectedRows.emit(this.selectedIds);
      this.selectedDataRows.emit(this.selectedItems);
    } else {
      this.selectedIds = this.selectedIds.filter(item => item !== row.id);
      this.selectedItems = this.selectedItems.filter(item => item.id !== row.id);
      this.selectedRows.emit(this.selectedIds);
      this.selectedDataRows.emit(this.selectedItems);
    }

    this.removeSelected = this.selectedIds;
  }

  selectAll(event) {
    this.selectedItems = [];
    if (event.target.checked) {
      this.checkedAll = true;
      this.pagination.data.forEach(item => {
        this.selectedIds.push(item.id);
        this.selectedItems.push(item);
      });
    } else {
      this.checkedAll = false;
      this.selectedIds = [];
      this.selectedItems = [];
    }
    this.selectedRows.emit(this.selectedIds);
    this.selectedDataRows.emit(this.selectedItems);
  }

  bulkAction() {
    if (this.selectedAction === Order.GENERATE_INVOICE_ACTION) {
      this.generateInvoiceAction.emit(this.selectedIds);
    } else {
      if(this.selectedIds.length){
        this.changeOrderStatusProcessing = true;
        const params = {action: this.selectedAction, ids: this.selectedIds, confirm: this.confirmAction, notify: this.notifyAction};
        this.grid.service[this.grid.bulkActionMethod](params).subscribe(res => {
          this.bulkActionResponse.emit(res);
          this.confirmAction = false;
          this.notifyAction = false;
          this.checkedAll = false;
          this.selectedIds = [];
          this.sendRequest(null);
          this.changeOrderStatusProcessing = false;
        });
      }
    }
  }

  invoiceBulkAction() {
    if(this.selectedIds.length>0){
      const params = {action: this.selectedAction, ids: this.selectedIds};
      this.grid.service[this.grid.bulkActionMethod](params).subscribe(res => {
        this.bulkActionResponse.emit(res);
        this.checkedAll = false;
        this.selectedIds = [];
      });
      this.sendRequest(null);
    }
  }

  selectAction(event) {
    if (Helper.isDefined(event)) {
      this.selectedAction = event.value;
    }
  }

  searchKeyUp($event) {
    this.searchSubject.next($event.target.value);
  }

  isActionDisabled(actionItem: ActionItem, row: any): boolean {
    return !!(actionItem.disabledCallback && actionItem.disabledCallback(row));
  }

  onActionClick(event: MouseEvent, actionItem: ActionItem, row: any): void {
    if (this.isActionDisabled(actionItem, row)) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    actionItem.onclick(row);
  }

  refreshFilter() {
    if (Helper.isDefined(this.grid.rememberURL)) {
      sessionStorage.removeItem(this.grid.rememberURL);
      this.searchQuery = new SearchQuery();
      this.searchQuery.sortBy = this.grid.defaultSort;
      this.searchQuery.sortType = this.grid.defaultSortType;
      this.searchQuery.filter = {} as any;
      this.addSelectedItems();
      this.sendRequest(null);
    }
  }

  selectRow(event) {
    if (event.type === 'click' && this.table.rowDetail && event.column.type !== BooleanColumn.type) {
      this.table.rowDetail.toggleExpandRow(event.row);
    }
  }

  openFilterTab(column) {
    column.isFilterTabOpen = !column.isFilterTabOpen;
  }

  closeFilterTab(column) {
    column.isFilterTabOpen = false;
  }

  filterChange(column) {
    const selected = [];
    if ( column.filterMultiSelect ) {
      column.filterSelectedItems.forEach(item => {
        selected.push(item);
       });
    } else {
      if ( Helper.isDefined(column.filterSelectedItems) && column.filterSelectedItems !== null) {
        selected.push(column.filterSelectedItems);
      }
    }
    const filterKey = column.filterProp || column.prop;
    this.searchQuery.filter[filterKey] = selected;
    column.isFilterSelected = this.searchQuery.filter[filterKey].length > 0;
    this.sendRequest(null);
  }

  addSelectedItems() {
    this.columns.forEach(column => {
      if (column.filterable) {
        const filterKey = column.filterProp || column.prop;
        if ( this.searchQuery.filter[filterKey] && this.searchQuery.filter[filterKey].length > 0) {
          if ( column.filterMultiSelect) {
            column.filterSelectedItems = this.searchQuery.filter[filterKey];
          } else {
            column.filterSelectedItems = this.searchQuery.filter[filterKey][0];
          }
          column.isFilterSelected = true;
        } else {
          column.isFilterSelected = false;
          column.filterSelectedItems = [];
        }
      }
    });
  }
}
